import {Injectable} from '@angular/core';
import {CameraManagerService} from './camera-manager.service';
import {
  CapacitorBarcodeScanner,
  CapacitorBarcodeScannerScanResult,
  CapacitorBarcodeScannerTypeHintALLOption
} from '@capacitor/barcode-scanner';

@Injectable({
  providedIn: 'root'
})
export class BarcodeScannerManagerService {

  constructor(
    protected cameraManager: CameraManagerService
  ) {
  }


  /**
   * Obtener el dato del escáner de código de barras
   *
   */
  public async getBarcodeScannerData(): Promise<string | null> {

    try {

      const hasCameraPermission: boolean = await this.cameraManager.checkCameraPermissions();

      if (!hasCameraPermission) {
        return null;
      }

      const result: CapacitorBarcodeScannerScanResult = await CapacitorBarcodeScanner.scanBarcode({
        hint: CapacitorBarcodeScannerTypeHintALLOption.ALL
      });

      return result.ScanResult;

    } catch (error) {

      console.error('Error scanning barcode:', error);
      return null;
    }

  }

}
